import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isIOS } from './InstallBanner';
import './PwaInstallSection.css';

export default function PwaInstallSection() {
  const navigate = useNavigate();
  const ios = isIOS();

  return (
    <section className="pwa-install reveal" id="pwa-install">
      <div className="pwa-install__inner">
        <div className="pwa-install__header">
          <h2 className="pwa-install__title">Als Web-App nutzen</h2>
          <p className="pwa-install__subtitle">
            Füge TechSoul zu deinem Home-Bildschirm hinzu – kein App Store nötig.
          </p>
        </div>

        <div className="pwa-install__cards">
          <div className="pwa-install__card pwa-install__card--work">
            <img src="/icons/work-192.png" alt="TechSoul Work" className="pwa-install__icon" />
            <div className="pwa-install__card-body">
              <h3 className="pwa-install__card-name">TechSoul Work</h3>
              <p className="pwa-install__card-desc">
                Meetings, Entscheidungen, Übergaben – KI-Tools für deinen Arbeitsalltag.
              </p>
              {ios && (
                <p className="pwa-install__ios-hint">
                  Safari → Teilen → Zum Home-Bildschirm
                </p>
              )}
              <button
                className="pwa-install__btn pwa-install__btn--work"
                onClick={() => navigate('/app/work')}
              >
                {ios ? 'iOS-Anleitung ansehen' : 'TechSoul Work starten'}
              </button>
            </div>
          </div>

          <div className="pwa-install__card pwa-install__card--life">
            <img src="/icons/life-192.png" alt="TechSoul Life" className="pwa-install__icon" />
            <div className="pwa-install__card-body">
              <h3 className="pwa-install__card-name">TechSoul Life</h3>
              <p className="pwa-install__card-desc">
                Ernährung, Ideen, Alltag – KI-Tools für dein persönliches Leben.
              </p>
              {ios && (
                <p className="pwa-install__ios-hint">
                  Safari → Teilen → Zum Home-Bildschirm
                </p>
              )}
              <button
                className="pwa-install__btn pwa-install__btn--life"
                onClick={() => navigate('/app/life')}
              >
                {ios ? 'iOS-Anleitung ansehen' : 'TechSoul Life starten'}
              </button>
            </div>
          </div>
        </div>

        <p className="pwa-install__note">
          Beide Apps nutzen dieselbe Plattform – du kannst beide installieren.
        </p>
      </div>
    </section>
  );
}
